import { formatEuros } from './format'

export function formatHmm(value: number): string {
  const minutes = Math.max(0, Math.round(value * 60))
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return `${h}:${String(m).padStart(2, '0')}`
}

/**
 * Accepteert zowel h:mm ("1:30") als decimaal ("1,5" / "1.5") als kale uren ("2").
 * Minuten moeten exact twee cijfers 00-59 zijn; "1:5" en "0:75" zijn ongeldig.
 * Retourneert null bij ongeldige invoer of meer dan 24 uur; lege invoer is ook null.
 */
export function parseFlexibleHours(input: string): number | null {
  const trimmed = input.trim()
  if (trimmed === '') return null
  const hmm = /^(\d{1,2}):([0-5]\d)$/.exec(trimmed)
  if (hmm) {
    const value = Math.round((Number(hmm[1]) + Number(hmm[2]) / 60) * 100) / 100
    return value <= 24 ? value : null
  }
  if (/^\d{1,2}([.,]\d{1,2})?$/.test(trimmed)) {
    const value = Number(trimmed.replace(',', '.'))
    return value <= 24 ? value : null
  }
  return null
}

export function parseMoney(input: string): number {
  const normalized = input.replace(',', '.').trim()
  if (normalized === '') return 0
  const value = Number(normalized)
  return Number.isFinite(value) ? value : 0
}

/** Hoogste reiskostenbedrag per regel; spiegelt `TravelAmount::MAX` in de backend. */
export const MAX_TRAVEL_AMOUNT = 9999.99

/**
 * Strikte tegenhanger van parseMoney: null zodra de invoer geen bedrag is, zodat het
 * formulier dat kan melden in plaats van er stilzwijgend nul van te maken. Lege invoer
 * is ook null; die betekenis (wel of geen reiskosten) hoort bij de aanroeper.
 */
export function parseMoneyStrict(input: string): number | null {
  const trimmed = input.trim()
  if (!/^\d{1,12}([.,]\d{1,2})?$/.test(trimmed)) return null
  return Number(trimmed.replace(',', '.'))
}

/**
 * Melding bij een ingevoerd reiskostenbedrag, of null als het klopt. De weekcel en de
 * dagweergave delen deze tekst, zodat dezelfde invoer overal hetzelfde oordeel krijgt.
 */
export function travelMessage(parsed: number | null): string | null {
  if (parsed === null) return 'Ongeldig bedrag, gebruik bijv. 12,50'
  if (parsed > MAX_TRAVEL_AMOUNT) return `Maximaal ${formatEuros(MAX_TRAVEL_AMOUNT)} per regel`
  return null
}
